import { Form } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledFormLabel = styled(Form.Label)`
  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 0.3rem;
  }
`;

export const StyledFormGroup = styled(Form.Group)`
  @media (max-width: 768px) {
    margin-bottom: 0.7rem;
  }
`;

export const NonEditableField = styled.div`
  display: block;
  width: 100%;
  height: calc(1.5em + 0.2rem + 2px);
  padding: 0.1rem 0.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.12rem;
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  background-color: #e9ecef;
`;

export const DatePickerContainer = styled.div`
  flex: 1;
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input {
    width: 124px;
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
  input {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.2rem + 2px);
    padding: 0.1rem 0.5rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.12rem;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }
`;

export const DirectionButton = styled.div<{
  isBullish?: boolean;
  isDisable?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 30px;
  color: white;
  border-radius: 5px;
  background-color: ${props => (props.isBullish ? '#317fff' : '#ff6903')};
  margin-right: ${props => (props.isBullish ? '5px' : '0')};
  margin-left: ${props => (props.isBullish ? '0' : '5px')};
  cursor: pointer;
  opacity: ${props => (props.isDisable ? '40%' : 1)};
`;
